module.exports = __webpack_public_path__ + "static/media/starHauler.8b142de8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/starHauler.png
// module id = 2217
// module chunks = 0